"use client";

import { CATEGORIES } from "@/constants/categories";
import CategoryPage from "../CategoryPage";

export default function EntertainmentCategory() {
    return (
        <CategoryPage
            category={CATEGORIES.entertainment}
        />
    )
} 